import { useFeature } from "@coherehealth/common";
import { useAuthorized } from "Authorization";
import { Box } from "@mui/material";
import { useState } from "react";
import { UploadIconButton } from "./UploadIconButton";
import { UploadCaseDrawer } from "./UploadCaseDrawer";

type UploadCaseProps = {
  allowUploads?: boolean;
  activeQueueId?: string;
};

export const UploadCase = ({ allowUploads, activeQueueId }: UploadCaseProps) => {
  const uploadCasesForAuditFF = useFeature("uploadCasesForAuditQueue");
  const hasAuditReviewerRole = useAuthorized("AUDIT_REVIEW");
  const [openDrawer, setOpenDrawer] = useState(false);

  const shouldDisplayUploadCasesContainer = hasAuditReviewerRole && allowUploads && uploadCasesForAuditFF;
  return shouldDisplayUploadCasesContainer ? (
    <>
      <Box sx={{ marginTop: 5 }}>
        <UploadIconButton data-testid="uploadCasesForAuditQueue" onClick={() => setOpenDrawer(true)}>
          Upload cases
        </UploadIconButton>
      </Box>
      <UploadCaseDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} queueId={activeQueueId || ""} />
    </>
  ) : (
    <></>
  );
};
